<div class="ui-g">
  <div class="ui-g-12">
    <p-radioButton [label]=" 'DATA_PORTAL.INTERACTIONS.DETAIL.ALL' | translate "
                   [value]="timeFilters.ALL"
                   [(ngModel)]="filter.lastDays"
                   class="m-r-15 inline-block m-b-0"
                   (ngModelChange)="search.emit()">
    </p-radioButton>
    <p-radioButton [label]=" 'DATA_PORTAL.INTERACTIONS.DETAIL.LAST_MONTH' | translate "
                   [value]="timeFilters.LAST_MONTH"
                   [(ngModel)]="filter.lastDays"
                   class="m-r-15 inline-block m-b-0"
                   (ngModelChange)="search.emit()">
    </p-radioButton>
    <p-radioButton [label]=" 'DATA_PORTAL.INTERACTIONS.DETAIL.LAST_YEAR' | translate "
                   [value]="timeFilters.LAST_YEAR"
                   [(ngModel)]="filter.lastDays"
                   class="m-r-15 inline-block m-b-0"
                   (ngModelChange)="search.emit()">
    </p-radioButton>
  </div>
</div>

<div class="ui-g">
  <div class="ui-g-4">
    <p-checkbox [(ngModel)]="filter.important"
                (ngModelChange)="search.emit()"
                label="{{ 'DATA_PORTAL.INTERACTIONS.DETAIL.IMPORTANT' | translate }}"
                binary="true"
                class="m-t-10">
    </p-checkbox>
  </div>
  <div class="ui-g-4 ui-g-offset-4">
    <input
      pInputText
      [(ngModel)]="filter.value"
      [placeholder]="'DATA_PORTAL.INTERACTIONS.DETAIL.PLACEHOLDER' | translate"
      (ngModelChange)="search.emit()">
  </div>
</div>
